<template lang='pug'>
.main-container
  .view-content
    el-card
      div(slot='header')
        i.mat-icon assignment
        | Requests for estimates
        el-button(type="primary", @click="goToRequestBuilder()", style='float: right')
          i.mat-icon add_circle
          | New request

      el-tabs( v-model='activeIndex', type='card' )
        el-row(:gutter='10')
          el-col(:span='9')
            el-input(v-model='sorting' prefix-icon="el-icon-search" placeholder="Search")
        el-tab-pane(v-for='filter in filters', :label='$filterToStaffName(filter)',
          :name='filter', :key='filter')
          request-list(:filter='filter', :sorting='sorting', v-if='filter == activeIndex')

  router-view
</template>

<script>
import RequestList from './blocks/RequestList.vue'

function data(){
  return {
    filters: ['open', 'closed'],
    sorting:'',
    activeIndex: 'open',
  }
}

function goToRequestBuilder ( ) {
  this.$router.push("/user/requests/new")
}

const components = { RequestList }

const methods = { goToRequestBuilder }

export default { methods, components, data }
</script>


// WEBPACK FOOTER //
// src/user/Requests.vue